import CountryPageTemplate from './CountryPageTemplate';

export default function AustriaPage() {
  return <CountryPageTemplate countryKey="at" />;
}